import React, { useState, useEffect, } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import Button from '@material-ui/core/Button';

import { FORECASTS as FLOOD_FORECASTS, RISKS as FLOOD_RISKS } from '../mapLayers/Flood'

const useStyles = makeStyles(() => ({
    root: {
        height: '100vh',
        width: 400,
        backgroundColor: '#272727',
        color: '#EBEBEB',
    },
    datagrid: {
        backgroundColor: '#272727',
        color: '#EBEBEB',
        '& .MuiDataGrid-root': {
            color: '#EBEBEB',
        },
        '& .MuiTablePagination-root': {
            color: '#EBEBEB',
        },
        '& .MuiDataGrid-overlay': {
            backgroundColor: '#272727',
            color: '#EBEBEB',
        },
        '& .MuiButtonBase-root': {
            color: '#EBEBEB',
        },
    },
}));

export default function FloodPanel(props) {
    const { map, floodLayer, onClose, onSelectRisk, onSelectForecast } = props;
    const classes = useStyles();

    let riskRows = [];
    let forecastRows = [];
    if (map) {

        const rivers = floodLayer.layer.getRivers();

        // ソートは DataGrid にまかせて、ここでは何もしない。

        riskRows = Object.keys(rivers.risks).map(key => {
            const risk = rivers.risks[key];
            return { id: key, ...risk };
        })

        forecastRows = Object.keys(rivers.forecasts).map(key => {
            const forecast = rivers.forecasts[key];
            return { id: key, ...forecast };
        })
    }

    const riskColumns = [
        {
            field: 'name', headerName: '河川', type: 'string', flex: 1, sortable: true,
            renderCell: ({ value }) => value ? value : '（名称不明）'
        },
        {
            field: 'code-name', headerName: '洪水危険度判定値', type: 'string', flex: 1, sortable: true,
            valueGetter: (params) => `${FLOOD_RISKS[params.getValue(params.id, 'code')]}`,
            sortComparator: (v1, v2, param1, param2) => param1.api.getCellValue(param1.id, 'code') - param2.api.getCellValue(param2.id, 'code'),
        },
    ];

    const forecastColumns = [
        {
            field: 'name', headerName: '予報区域', type: 'string', flex: 1, sortable: true,
            renderCell: ({ value }) => value ? value : '（名称不明）'
        },
        {
            field: 'code-name', headerName: '指定河川洪水予報の種類', type: 'string', flex: 1, sortable: true,
            valueGetter: (params) => `${FLOOD_FORECASTS[params.getValue(params.id, 'code')]}`,
            sortComparator: (v1, v2, param1, param2) => param1.api.getCellValue(param1.id, 'code') - param2.api.getCellValue(param2.id, 'code'),
        },
    ];

    const sortModel = [
        {
            field: 'code-name',
            sort: 'desc',
        },
    ];

    return (
        <Box className={classes.root} >
            <Box p={0.5} mb={1} style={{ height: '45%' }}>
                <Typography variant="h2">指定河川洪水予報</Typography>
                <Box style={{ height: '90%' }} >
                    <DataGrid className={classes.datagrid}
                        rows={forecastRows}
                        columns={forecastColumns}
                        disableColumnMenu={true}
                        headerHeight={30}
                        rowHeight={30}
                        pageSize={10}
                        hideFooterSelectedRowCount={true}
                        sortModel={sortModel}
                        onRowClick={(param) => onSelectForecast(param)}
                    />
                </Box>
            </Box>

            <Box p={0.5} mb={1} style={{ height: '45%' }}>
                <Typography variant="h2">洪水害の危険度</Typography>
                <Box style={{ height: '90%' }} >
                    <DataGrid className={classes.datagrid}
                        rows={riskRows}
                        columns={riskColumns}
                        disableColumnMenu={true}
                        headerHeight={30}
                        rowHeight={30}
                        pageSize={10}
                        hideFooterSelectedRowCount={true}
                        sortModel={sortModel}
                        onRowClick={(param) => onSelectRisk(param)}
                    />
                </Box>
            </Box>
            <Box pl={0.5} pb={0.5} >
                <Button variant="contained" color="primary" onClick={onClose}>
                    閉じる
                </Button>
            </Box>
        </Box >
    )
};
